import { createAction } from '@reduxjs/toolkit';
import EcomEngineAPI from 'api/ecom_engine_api';
import { trackError } from 'utils/helpers';

const changePasswordStarted = createAction('account/changePasswordStarted');
const changePasswordSucceeded = createAction('account/changePasswordSucceeded');
const changePasswordFailure = createAction('account/createReservationFailure');

const changePassword =
  ({ password, password_confirmation, password_current }) =>
  (dispatch) => {
    dispatch(changePasswordStarted());

    return EcomEngineAPI.account
      .changePassword({ password, password_confirmation, password_current })
      .then(() => {
        dispatch(changePasswordSucceeded());
      })
      .catch((error) => {
        trackError(error);
        dispatch(changePasswordFailure(error.message));
      });
  };

export {
  changePasswordStarted,
  changePasswordSucceeded,
  changePasswordFailure,
  changePassword,
};
